"use strict";
import * as bgBG from "./bg-BG.json.js";
import * as csCZ from "./cs-CZ.json.js";
import * as daDK from "./da-DK.json.js";
import * as deAT from "./de-AT.json.js";
import * as deCH from "./de-CH.json.js";
import * as deDE from "./de-DE.json.js";
import * as deLU from "./de-LU.json.js";
import * as elCY from "./el-CY.json.js";
import * as elGR from "./el-GR.json.js";
import * as enAU from "./en-AU.json.js";
import * as enGB from "./en-GB.json.js";
import * as enIE from "./en-IE.json.js";
import * as enMT from "./en-MT.json.js";
import * as enUS from "./en-US.json.js";
import * as esCL from "./es-CL.json.js";
import * as esCO from "./es-CO.json.js";
import * as esES from "./es-ES.json.js";
import * as esMX from "./es-MX.json.js";
import * as esPE from "./es-PE.json.js";
import * as esUS from "./es-US.json.js";
import * as etEE from "./et-EE.json.js";
import * as fiFI from "./fi-FI.json.js";
import * as frBE from "./fr-BE.json.js";
import * as frCH from "./fr-CH.json.js";
import * as frFR from "./fr-FR.json.js";
import * as frLU from "./fr-LU.json.js";
import * as hrHR from "./hr-HR.json.js";
import * as huHU from "./hu-HU.json.js";
import * as itCH from "./it-CH.json.js";
import * as itIT from "./it-IT.json.js";
import * as ltLT from "./lt-LT.json.js";
import * as lvLV from "./lv-LV.json.js";
import * as nbNO from "./nb-NO.json.js";
import * as nlBE from "./nl-BE.json.js";
import * as nlNL from "./nl-NL.json.js";
import * as plPL from "./pl-PL.json.js";
import * as ptBR from "./pt-BR.json.js";
import * as ptPT from "./pt-PT.json.js";
import * as roRO from "./ro-RO.json.js";
import * as skSK from "./sk-SK.json.js";
import * as slSI from "./sl-SI.json.js";
import * as svSE from "./sv-SE.json.js";
import { transformModulesToTranslations } from "../../../util/i18n.js";
const translations = transformModulesToTranslations(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore import.meta.glob is supported by Vite
  /* @__PURE__ */ Object.assign({
    "./bg-BG.json": bgBG,
    "./cs-CZ.json": csCZ,
    "./da-DK.json": daDK,
    "./de-AT.json": deAT,
    "./de-CH.json": deCH,
    "./de-DE.json": deDE,
    "./de-LU.json": deLU,
    "./el-CY.json": elCY,
    "./el-GR.json": elGR,
    "./en-AU.json": enAU,
    "./en-GB.json": enGB,
    "./en-IE.json": enIE,
    "./en-MT.json": enMT,
    "./en-US.json": enUS,
    "./es-CL.json": esCL,
    "./es-CO.json": esCO,
    "./es-ES.json": esES,
    "./es-MX.json": esMX,
    "./es-PE.json": esPE,
    "./es-US.json": esUS,
    "./et-EE.json": etEE,
    "./fi-FI.json": fiFI,
    "./fr-BE.json": frBE,
    "./fr-CH.json": frCH,
    "./fr-FR.json": frFR,
    "./fr-LU.json": frLU,
    "./hr-HR.json": hrHR,
    "./hu-HU.json": huHU,
    "./it-CH.json": itCH,
    "./it-IT.json": itIT,
    "./lt-LT.json": ltLT,
    "./lv-LV.json": lvLV,
    "./nb-NO.json": nbNO,
    "./nl-BE.json": nlBE,
    "./nl-NL.json": nlNL,
    "./pl-PL.json": plPL,
    "./pt-BR.json": ptBR,
    "./pt-PT.json": ptPT,
    "./ro-RO.json": roRO,
    "./sk-SK.json": skSK,
    "./sl-SI.json": slSI,
    "./sv-SE.json": svSE
  })
);
export {
  translations
};
